/**
 * @generated SignedSource<<052943f87088113a108dc5e97c5d0ecb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PerformanceByYear_component$data = {
  readonly lineItems: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"PerformanceByYearLineItem_component">;
  }>;
  readonly performanceTitle: string;
  readonly " $fragmentType": "PerformanceByYear_component";
};
export type PerformanceByYear_component$key = {
  readonly " $data"?: PerformanceByYear_component$data;
  readonly " $fragmentSpreads": FragmentRefs<"PerformanceByYear_component">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PerformanceByYear_component",
  "selections": [
    {
      "alias": "performanceTitle",
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PerformanceByYearLineItem",
      "kind": "LinkedField",
      "name": "lineItems",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PerformanceByYearLineItem_component"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PerformanceByYear",
  "abstractKey": null
};

(node as any).hash = "0c894abbb919bc5e7fd2d0a9f2f9b2f8";

export default node;
